import CheckIcon from "@mui/icons-material/CheckRounded";
import LinkIcon from "@mui/icons-material/InsertLinkRounded";
import { Button } from "@mui/material";
import { useState } from "react";
import { getErrorMessage } from "@entrilia/shared/api/axiosHelper";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext";

interface Props {
  url: string;
}

const CopyLinkButton = ({ url }: Props) => {
  const { sendNotificationError } = useNotificationContext();
  const [isCopied, setIsCopied] = useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      setIsCopied(false);
      sendNotificationError(`Failed to copy: ${getErrorMessage(error)}`);
      return;
    }

    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <Button
      variant="outlined"
      color="secondary"
      startIcon={isCopied ? <CheckIcon /> : <LinkIcon />}
      onClick={handleClick}
    >
      {isCopied ? "Copied" : "Copy Link"}
    </Button>
  );
};

export default CopyLinkButton;
